import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"


import { onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import CosRangePicker from '@/components/CosRangePicker/index'
import { CustomerCodeParams, CustomerCode } from '@/typings/api/customerCenter'
import { customerCodeGet, customerCodeDelete, customerCodeDetail } from '@/api/gucangSales/customerCenter'
import { getLevelOrGrade } from '@/api/common'
import editModal from './editModal.vue'
import { useRouter } from 'vue-router'
const __default__ = { name: 'DcCosFbuAccountCode' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const editModalRef = ref()
const tableRef = ref()
const level = ref<
  {
    id: number
    max: number
    min: number
    configName: string
  }[]
>([])
const searchFrom = ref<CustomerCodeParams>({
  stage: [],
  contact: {
    type: 1
  },
  content: ''
})
const columns = ref([
  {
    title: '子客户代码名称',
    dataIndex: 'arkAccount',
    cosType: 'link',
    path: '/fbu/accountCode/view',
    query: ['id', 'arkCode', 'cosId'],
    fixed: 'left',
    width: 150
  },
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '主客户代码',
    dataIndex: 'customerNumber'
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '客户ID',
    dataIndex: 'cosId',
    width: 120
  },
  {
    title: '联系人姓名',
    dataIndex: 'arkContactName',
    cosType: 'mask',
    width: 120,
    headerQuestion: '取值来源：ark账号审核-联系人姓名'
  },
  {
    title: '手机号',
    dataIndex: 'arkContactMobile',
    cosType: 'mask',
    headerQuestion: '取值来源：ark账号审核-手机号'
  },
  {
    title: '客户负责人',
    dataIndex: 'sellerName',
    headerQuestion: '取值来源：ark账号审核-销售代表',
    width: 120
  },
  {
    title: '客户阶段',
    dataIndex: 'stage',
    dicData: dataConfig.customerPhaseEnum
  },
  {
    title: '档次',
    dataIndex: 'level'
  },
  {
    title: '成交金额（万）',
    dataIndex: 'amount',
    width: 120
  },
  {
    title: 'ark账号状态',
    dataIndex: 'status',
    dicData: [
      { value: 0, label: '待审核' },
      { value: 1, label: '审核不通过' },
      { value: 2, label: '审核通过' },
      { value: 3, label: '已停用' },
      { value: 4, label: '冻结' },
      { value: 5, label: '限制' }
    ]
  },
  {
    title: '主体数量',
    dataIndex: 'subjectCount'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 120
  }
])
const fetch = (params: CustomerCodeParams, callBack: (res: any) => void) => {
  // 重组档次搜索
  const levelList: { min: number; max: number }[] = []
  if (searchFrom.value.level && searchFrom.value.level.length) {
    searchFrom.value.level.forEach((item) => {
      const obj = level.value.find((v: any) => item === v.id)
      if (obj) {
        levelList.push({
          min: obj.min,
          max: obj.max
        })
      }
    })
  }
  searchFrom.value.levelList = levelList
  customerCodeGet({
    ...params,
    levelList
  }).then((res) => {
    callBack(res)
  })
}
const showMask = (record: CustomerCode, callBack: (res: any) => void) => {
  if (record.id) {
    customerCodeDetail(record.id).then((res) => {
      callBack(res.data)
    })
  }
}
onMounted(() => {
  fetchLevel()
})
const fetchLevel = () => {
  getLevelOrGrade({
    configType: 1,
    appId: 'cos_fbu'
  }).then((res) => {
    level.value = res.data
  })
}
const addEdit = (row: CustomerCode) => {
  editModalRef.value?.toggle(row)
}
const deleteRow = (row: CustomerCode) => {
  Modal.delete({
    name: row.arkCode,
    onOk() {
      customerCodeDelete({ idList: [row.id] }).then(() => {
        message.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 跳转到签约主体列表
const linkToMainBody = (row: CustomerCode) => {
  if (!row.subjectCount) {
    return
  }
  router.push({
    path: '/fbu/mainBody',
    query: {
      customerCode: row.arkCode
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: searchFrom.value,
            "onUpdate:search": _cache[10] || (_cache[10] = ($event: any) => ((searchFrom).value = $event)),
            onFetch: fetch,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "fbuAccountCode"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "主客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerNumber,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.customerNumber) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "手机号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.arkContactMobile,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.arkContactMobile) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "stage",
                    label: "客户阶段"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.stage,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.stage) = $event)),
                        placeholder: "请选择",
                        mode: "multiple",
                        allowClear: "",
                        options: _unref(dataConfig).customerPhaseEnum
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "子客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.arkCode,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.arkCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "子客户代码名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.arkAccount,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.arkAccount) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "level",
                    label: "档次"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.level,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.level) = $event)),
                        fieldNames: { label: 'configName', value: 'id' },
                        mode: "multiple",
                        allowClear: "",
                        placeholder: "请选择",
                        options: level.value
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "seller",
                    label: "客户负责人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.seller,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.seller) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "createTime",
                    label: "创建时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CosRangePicker), {
                        startTime: searchFrom.value.createTimeStart,
                        "onUpdate:startTime": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.value.createTimeStart) = $event)),
                        endTime: searchFrom.value.createTimeEnd,
                        "onUpdate:endTime": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom.value.createTimeEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: addEdit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新增 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_arkcode_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_fbu",
                taskType: "206",
                search: searchFrom.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'fbu_arkcode_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_MoreButton, { key: 0 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 编辑 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_arkcode_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_arkcode_del_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (column.dataIndex === 'subjectCount')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "link",
                    onClick: ($event: any) => (linkToMainBody(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(text || 0), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})